export function dropFromList(list, location) {
    let newSelected = []

    if (location === 0) {
        newSelected = newSelected.concat(list.slice(1));
    } else if (location === list.length - 1) {
        newSelected = newSelected.concat(list.slice(0, -1));
    } else if (location > 0) {
        newSelected = newSelected.concat(
            list.slice(0, location),
            list.slice(location + 1),
        );
    }

    return newSelected
}